// "Concluídas hoje" (recolhível): riscadas, com o tempo gasto e a estimativa (P0.3).
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { buildBoard } from '../domain/ordering';
import { formatMinutes, formatSpent } from '../i18n/format';
import { useAppState, useStore } from '../state/AppStore';
import { useNow } from '../state/useNow';
import { useAccess } from '../state/useSubscription';
import { Icon } from './Icon';
import { cls } from './NewTaskForm';
import { SectionTrash } from './SectionTrash';

export function DoneSection() {
  const { t } = useTranslation();
  const store = useStore();
  const access = useAccess();
  const tasks = useAppState((s) => s.tasks);
  const now = useNow(30_000);
  const [open, setOpen] = useState(true);
  const done = buildBoard(tasks, new Date(now)).doneToday;
  if (!done.length) return null;
  const total = done.reduce((sum, x) => sum + x.elapsed_seconds, 0);

  return (
    <section className="section section--done" data-section="done" aria-labelledby="sec-done">
      <div className="section__bar">
        <h3 className="section__head" id="sec-done">
          <button type="button" className="section__toggle" aria-expanded={open} onClick={() => setOpen(!open)}>
            <span>{t('sections.done')}</span>
            <span className="section__count">{done.length}</span>
            <span className="section__extra">{formatSpent(total, t)}</span>
            <Icon name="chevronDown" size={14} className={cls('chev', !open && 'chev--closed')} />
          </button>
        </h3>
        {/* apaga as concluídas de hoje, depois de perguntar (AC-235) */}
        <SectionTrash
          label={t('sections.deleteAll', { section: t('sections.done') })}
          title={t('sections.deleteAllTitle', { count: done.length, section: t('sections.done') })}
          body={t('sections.deleteAllBody')}
          disabled={!access.canEdit}
          onConfirm={() => store.deleteTasks(done.map((x) => x.id))}
        />
      </div>
      {open && (
        <ul className="section__list">
          {done.map((task) => (
            <li key={task.id} className="done" data-testid="done-row">
              <span className="done__check">
                <Icon name="check" size={12} />
              </span>
              <s className="done__title">{task.title}</s>
              <span className="done__time">
                {task.estimate_minutes
                  ? t('done.spentWithEstimate', { spent: formatSpent(task.elapsed_seconds, t), est: formatMinutes(task.estimate_minutes, t) })
                  : formatSpent(task.elapsed_seconds, t)}
              </span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
